import { TimeMetricHandler } from '@edreamsodigeo/frontend-core';
import RequestHandler from './RequestHandler';
import { createSearchHandlers } from './createHandlers';
const LOAD_ITINERARIES_METRIC_KEY = 'LOAD_RESULTS_FLIGHTS_OF2';
const LOAD_SEM_ITINERARIES_METRIC_KEY = 'LOAD_SEM_LANDING_RESULTS_FLIGHTS';
const METRIC_SCOPE = 'fe-shell:metric';
export const createSearchIntegration = (storageClient, of1Props) => {
  const requestHandler = RequestHandler();
  const searchHandler = createSearchHandlers(of1Props);
  const metricHandler = TimeMetricHandler(storageClient.get('sessionStorage'), LOAD_ITINERARIES_METRIC_KEY, METRIC_SCOPE);
  const semMetricHandler = TimeMetricHandler(storageClient.get('sessionStorage'), LOAD_SEM_ITINERARIES_METRIC_KEY, METRIC_SCOPE);
  return {
    searchHandler,
    requestHandler,
    metricHandler,
    semMetricHandler
  };
};